import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './SearchDestination.css'
import { formatAddressParts } from '../../utils/format'

import ActivityIndicator from '../ActivityIndicator/ActivityIndicator'
import Inputfield from '../Inputfield/Inputfield'
import LocationIcon from '../LocationIcon/LocationIcon'
import ToolTip from '../ToolTip/ToolTip'

function debounce(fn, delay) {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}

@CSSModules(styles, { allowMultiple: true })
export default class SearchDestination extends Component {
  static propTypes = {
    errorMessage: PropTypes.string,
    isSearching: PropTypes.bool,
    onChange: PropTypes.func,
    onDestinationSelected: PropTypes.func,
    placeholder: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.shape({})),
    search: PropTypes.func,
    searchPhrase: PropTypes.string,
    selected: PropTypes.bool,
    streetNumberToolTipVisible: PropTypes.bool,
    redirectMessageVisable: PropTypes.bool,
    redirectMessage: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string
  }
  static defaultProps = {
    results: []
  }

  constructor (props) {
    super(props)
    this.state = {
      searching: false,
      destinationSelected: props.selected
    }
    this.search = debounce(props.search, 200)
  }

  componentWillReceiveProps (nextProps) {
    const props = this.props
    if (nextProps.value === props.value) {
      this.setState({ searching: false })
    }
  }

  _destinationSelected (result) {
    const { onDestinationSelected } = this.props
    this.setState({ destinationSelected: true })
    this.refs.inputField.focus()
    onDestinationSelected(result)
  }

  _streetSearch (event) {
    const { onChange } = this.props
    onChange(event)
    this.setState({ searching: true, destinationSelected: false })
    this.search(event.target.value)
  }

  _renderNoResult(searchString) {
    const { searching, destinationSelected } = this.state
    if ((!searchString || searchString === '') || destinationSelected) return null
    if (searching) return (
      <ul styleName="search-results">
        <div styleName="activity-indicator">
          <ActivityIndicator />
        </div>
      </ul>
    )
    return (
      <ul styleName="search-results">
        <li>
        <span styleName="no-matches">Vi hittade inga adresser som matchar din sökning. <br/>Prova med en närliggande adress.</span>
        </li>
      </ul>
    )
  }

  _renderLocation (location) {
    const o = formatAddressParts(location)
    return (
      <div styleName="result-item">
        <div styleName="title">{o.title}</div>
        <div styleName="subtitle">{o.subtitle}</div>
      </div>
    )
  }

  _renderResults (results) {
    return (
      <ul styleName="search-results">
        {results
          .map((result, i) => {
            return (
              <li
                key={`option-${i}`}
                onClick={this._destinationSelected.bind(this, result)}>
                <a href="#">
                  <LocationIcon location={result} />
                  {this._renderLocation(result)}
                </a>
              </li>
            )
          })
        }
      </ul>
    )
  }

  render () {
    const results = this._renderResults(this.props.results)
    return (
      <div>
        <h2>
          {this.props.title}
          {this.props.redirectMessageVisable && <span styleName="redirect-message">{this.props.redirectMessage ? this.props.redirectMessage : "Vänligen välj en alternativ plats."}</span>}
        </h2>
        <div styleName="search-inputs">
          <ToolTip title="Vänligen fyll i gatunummer" isVisible={this.props.streetNumberToolTipVisible} />
          <Inputfield
            errorMessage={this.props.errorMessage}
            grow
            onChange={this._streetSearch.bind(this)}
            placeholder={this.props.placeholder}
            ref="inputField"
            type="search"
            value={this.props.value || ''}>
          </Inputfield>
        </div>
        <div styleName="searchfield">
          {this.props.results.length > 0
          ? results
          : this._renderNoResult(this.props.value)
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchDestination/SearchDestination.js